import { render, staticRenderFns } from "./KnittingQcForm.vue?vue&type=template&id=32daf759&scoped=true"
import script from "./KnittingQcForm.vue?vue&type=script&lang=js"
export * from "./KnittingQcForm.vue?vue&type=script&lang=js"
import style0 from "./KnittingQcForm.vue?vue&type=style&index=0&id=32daf759&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32daf759",
  null
  
)

export default component.exports